import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: 'rgb(69, 167, 247)',
            contrastText: '#ffffff',
        },
        error: {
            main: 'rgb(255, 64, 129)',
            contrastText: '#ffffff',
        },
        green: {
            main: 'rgb(17, 200, 195)',
            contrastText: '#ffffff',
        },
    },
});

export default theme;